import axios from './axios';

/**
 * calls the speicalty GET api to get the specialty details
 */
const getSpecialty = id => axios.get(`/specialty/${id}`);

export default getSpecialty;
